export default {
  model: {
    position: {
      notes: 'Name of position property on signal interval',
      message: 'Sensor',
    },
    severity: {
      notes: 'Name of severity property on signal interval',
      message: 'Severity',
    },
    signalName: {
      notes: 'Name of signal name property on signal interval',
      message: 'Signal name',
    },
    unit: {
      notes: 'Name of unit property on signal interval',
      message: 'Unit',
    },
    alarmOnOrBelow: {
      notes: 'Name of lower threshold property on signal interval',
      message: 'Lower threshold',
    },
    alarmOnOrAbove: {
      notes: 'Name of upper threshold property on signal interval',
      message: 'Upper threshold',
    },
  },
  list: {
    lowerThresholdsColumnGroup: {
      notes: 'Column header for lower thresholds',
      message: 'Lower thresholds',
    },
    upperThresholdsColumnGroup: {
      notes: 'Column header for upper thresholds',
      message: 'Upper thresholds',
    },
    noSignalSelected: {
      notes: 'Empty state text when no signal is selected',
      message: 'Please select a signal to edit thresholds',
    },
  },
  statistics: {
    header: {
      notes: 'Header in highlights section',
      message: 'Highlights: {{signalName}}',
    },
    emptyValues: {
      notes:
        'Label for KPI card showing number of thresholds with no set values',
      message: 'Thresholds not set',
    },
    modifiedValues: {
      notes:
        'Label for KPI card showing number of thresholds with modified values',
      message: 'Thresholds with modified values',
    },
    defaultValues: {
      notes:
        'Label for KPI card showing number of thresholds with default values',
      message: 'Thresholds with default values',
    },
  },
  applyDefaultToEmpty: {
    header: {
      notes:
        'Header in dialog to apply default thresholds where no value is set',
      message: 'Set thresholds with no value',
    },
    text: {
      notes: 'Text in dialog to apply default thresholds where no value is set',
      message: '{{count}} thresholds not set. Set to default values?',
    },
    apply: {
      notes:
        'Label on button to apply default thresholds where no values is set',
      message: 'Set',
    },
  },
  applyDefaultToModified: {
    header: {
      notes:
        'Header in dialog to apply default thresholds where they are modified',
      message: 'Set modified thresholds to default',
    },
    text: {
      notes:
        'Text in dialog to apply default thresholds where they are modified',
      message: 'Set {{count}} modified thresholds to default values?',
    },
    apply: {
      notes:
        'Label on button to apply default thresholds where they are modified',
      message: 'Set',
    },
    applyConfirm: {
      notes:
        'Confirm label when applying default thresholds where they are modified',
      message: 'Set and overwrite all values',
    },
  },
  initializationRequired: {
    text: {
      notes:
        'Text in empty state when no thresholds have been setup for the equipment.',
      message:
        'No thresholds have been set for the selected equipment. Click below to set all thresholds to default.',
    },
  },
  action: {
    reset: {
      atDefaultTooltip: {
        notes:
          'Tooltip for reset action when current value matches default value',
        message: 'Already using default value',
      },
      notAtDefaultTooltip: {
        notes:
          'Tooltip for reset action when current value is different from default value',
        message: 'Set to default value {{defaultValue}}',
      },
    },
    applyDefault: {
      notes: 'Label for action to set default thresholds',
      message: 'Set to default',
    },
  },
  helpEmptyThresholds: {
    notes: 'Help text when thresholds are not setup for equipment.',
    message:
      'Alarms will not be triggered for {{count}} thresholds that have not been set. Please select a signal to set thresholds.',
  },
};
